const encode = encodeURIComponent;

export default (requests, axios) => {
    return {
        getBetSlipTransactions: (betSlipId, combinationId = null) => {
            return requests.get(`transaction/public/${betSlipId}${combinationId ? `?multiCombinationId=${combinationId}` : ''}`);
        },
        getBetSlipTransaction: (betSlipId) => {
            return requests.get(`transaction/transactions/${betSlipId}`);
        }
    };
};
